export enum CommentStatus {
  unchecked = 'unchecked',
  checked = 'checked',
  notchecked = 'not-checked',
  open = 'open',
  answered = 'answered',
  closed = 'closed',
}

export type Comment = {
  text: string;
  status: CommentStatus;
  formId: string;
  fieldTemplateId: string;
  value: any;
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
  id: string;
};
